(() => {
	angular
		.module('main')
		.controller('UpdateQuoteController', UpdateQuoteController);

	UpdateQuoteController.$inject = ['$routeParams', '$scope'];

	function UpdateQuoteController($routeParams, $scope) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.idToGetQuote = $routeParams.jobId
				? parseInt($routeParams.jobId)
				: parseInt($routeParams.leadId);
			$scope.isJob = !!$routeParams.jobId;
			$scope.quoteId = $routeParams.quoteId;

			if ($routeParams.quoteType) {
				$scope.quoteType = $routeParams.quoteType;
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/updateQuoteController.js